import {
	IsPricePointSetFromCookieActionTypes,
	RESET_IS_PRICEPOINT_SET_FROM_COOKIE,
	SET_IS_PRICEPOINT_SET_FROM_COOKIE,
} from './isPricePointSetFromCookieActionTypes';

export const setIsPricePointSetFromCookie = (
	payload: boolean
): IsPricePointSetFromCookieActionTypes => ({
	type: SET_IS_PRICEPOINT_SET_FROM_COOKIE,
	payload,
});

export const resetIsPricePointSetFromCookie = (): IsPricePointSetFromCookieActionTypes => ({
	type: RESET_IS_PRICEPOINT_SET_FROM_COOKIE,
});
